"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("./");

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ButtonUpload extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onUpload", (acceptedFiles, rejectedFiles) => {
      if (this.props.onUpload) {
        this.props.onUpload(acceptedFiles, rejectedFiles);
      }
    });
  }

  render() {
    const _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          icon = _this$props.icon,
          accept = _this$props.accept,
          multiple = _this$props.multiple;
    return _react.default.createElement(_reactDropzone.default, {
      multiple: multiple,
      accept: accept,
      onDrop: event => this.onUpload(event)
    }, ({
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject
    }) => _react.default.createElement(_.Button, _extends({}, getRootProps(), {
      className: className
    }), _react.default.createElement("input", getInputProps()), _react.default.createElement(_.ButtonIcon, {
      icon: icon
    }), _react.default.createElement(_.ButtonLabel, {
      label: label
    })));
  }

}

_defineProperty(ButtonUpload, "defaultProps", {
  className: "admin-button  admin-button--secondary",
  label: "Upload",
  icon: ""
});

var _default = ButtonUpload;
exports.default = _default;
module.exports = exports.default;